import * as VoucherTheme from './components/Voucher.css';
import { createTheme } from '../utils';
export const defaultTheme = {
    VoucherTheme
};
export const { useTheme } = createTheme(defaultTheme);
